<div class="rfr_input-wrapper">
  <ion-item
      lines="none"
      [style]="style"
      [class]="'time-picker'"
      [ngClass]="{
        'rfr_ion-item': !readonly,
        'rfr_ion-item_read-only': readonly,
        'rfr-size-normal': size === 'normal',
        'rfr-size-large': size === 'large',
      }"
    >
    <!-- <ion-label position="floating">{{ labelText }}</ion-label> -->
    <ion-input
      readonly
      labelPlacement="floating"
      [ngClass]="{
        'rfr_input': true,
        'rfr_input_text-left': alignInputText === 'left',
        'rfr_input_text-right': alignInputText === 'right',
        'rfr_input_text-center': alignInputText === 'center',
        }"
      [value]="selectedDate"
      (click)="openDateTimePicker()"
    >
      <div class="rfr-label-text" slot="label">
        {{ labelText }} <ion-text color="danger" *ngIf="required">*</ion-text>
      </div>
    </ion-input>
  </ion-item>
  <ng-content select="[slot=error-message]"></ng-content>
</div>

<ion-modal [isOpen]="isDatePickerOpen" class="auto-height" (didDismiss)="closeDateTimePicker()">
  <ng-template>
    <ion-content>
      <ion-datetime
        presentation="time"
        hourCycle="h24"
        style="display: contents;"
        [(ngModel)]="tempSelectedDate"
      ></ion-datetime>
      <ion-footer>
        <ion-toolbar>
          <ion-buttons slot="end">
            <ion-button (click)="confirmDate()">OK</ion-button>
            <ion-button (click)="cancelDate()">Cancel</ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-footer>
    </ion-content>
  </ng-template>
</ion-modal>
